import type { LyricTimingV1 } from 'fym-shared/src/music24/lyricTiming';

/** What the Lyrics section shows next to Re-sync after a click. */
export type LyricResyncNote = { kind: 'error'; message: string } | { kind: 'done'; timesChanged: boolean };

/** The start of each line, by line index. */
export function lineStartsOf(timing: LyricTimingV1 | null | undefined): Array<number | null> {
  return timing === null || timing === undefined ? [] : timing.lines.map((line) => line.startMs);
}

/**
 * The note when a re-sync ends: null while the timing still syncs, and for a failed sync (the
 * failed card says why). `before` holds the line starts from before the click.
 */
export function resyncDoneNote(
  before: Array<number | null>,
  after: LyricTimingV1 | null | undefined
): LyricResyncNote | null {
  if (after === null || after === undefined || after.status !== 'synced') {
    return null;
  }
  const starts = lineStartsOf(after);
  const timesChanged = starts.length !== before.length || starts.some((startMs, index) => startMs !== before[index]);
  return { kind: 'done', timesChanged };
}
